import client from './inventory-request';
import { withStoreCreateBody } from '../hooks/useStoreScope';

// QC Rejections (grn-batch-service)
// API: GET /inventory/qc-rejections/ — tenant_id/hospital_id resolved server-side from Org-Code,
// never sent from the frontend. Caller passes only the filters actually set:
// purchase_order_id, vendor_id, item_id, replacement_status, actionable_only,
// from_date, to_date, search, limit, offset.
export const getQcRejections = (params = {}) =>
  client.get('/inventory/qc-rejections/', params);

// API: POST /inventory/qc-rejections/{grn_item_id}/replacement-grn/ (201)
// Backend always forces grn_kind=REPLACEMENT and derives purchase_order_id, vendor_id,
// receiving_store_id, item_id, uom_id, purchase_order_item_id from the source rejected line —
// none of those are accepted in the body.
export const createReplacementGrn = (grnItemId, body) =>
  client.post(`/inventory/qc-rejections/${grnItemId}/replacement-grn/`, withStoreCreateBody(body));
